export const modelEncodingEnum = Object.freeze({
    GLB: 'model/gltf-binary',
    USDZ: 'model/vnd.usdz+zip'
});  